import React from 'react';

export default function Status({ code, children, staticContext }) {
  if (staticContext) {
    staticContext.status = code;
  }

  return children;
}
